var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 193.78 215.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7{fill-rule:evenodd;}.cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5,.cls-6,.cls-7{isolation:isolate;}.cls-5{opacity:0.2;}.cls-6{opacity:0.12;}.cls-7{fill:#fff;opacity:0.25;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3803.92,
    y1: -1181.43,
    x2: 3697.22,
    y2: -1126.35,
    gradientTransform: "translate(-4923.46 3035.23) scale(1.32 2.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 3992.25,
    y1: -942.16,
    x2: 3796.45,
    y2: -942.16,
    gradientTransform: "translate(-3941.2 930.89) scale(1.04 0.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 3742.74,
    y1: -1030.82,
    x2: 3630.62,
    y2: -885.36,
    gradientTransform: "translate(-6252.3 1481.02) scale(1.7 1.31)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 3656.37,
    y1: -1171.15,
    x2: 3706.44,
    y2: -1106.16,
    gradientTransform: "translate(-6252.3 1478.86) scale(1.7 1.31)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1192",
    className: "cls-1",
    d: "M3.82,3.31C1.4,5.92,0,9.94,0,15.15V200.76C0,206,1.4,210,3.91,212.51l.66.56,104-104v-2.34L4.48,2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1203",
    className: "cls-2",
    d: "M143.17,143.87l-34.69-34.7v-2.43L143.18,72l.75.47,41,23.32c11.75,6.62,11.75,17.54,0,24.25l-41,23.33-.76.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1210",
    className: "cls-3",
    d: "M143.92,143.41,108.48,108,3.82,212.61c3.83,4.11,10.26,4.57,17.45.56l122.65-69.76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1223",
    className: "cls-4",
    d: "M143.92,72.52,21.27,2.85C14.09-1.26,7.65-.7,3.82,3.4L108.47,108Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1225",
    className: "cls-5",
    d: "M143.17,142.66,21.36,211.86c-6.81,3.92-12.87,3.65-16.79.09l-.66.66.66.56c3.92,3.54,10,3.82,16.79-.09L144,143.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1227",
    className: "cls-6",
    d: "M185,118.87l-41.88,23.79.75.75,41-23.33c5.87-3.35,8.77-7.73,8.77-12.12-.38,4-3.36,7.83-8.68,10.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1229",
    className: "cls-7",
    d: "M21.27,4.06,185,97.06c5.32,3,8.3,6.89,8.77,10.91,0-4.38-2.9-8.77-8.77-12.13L21.27,2.85C9.52-3.87,0,1.72,0,15.15v1.22C0,2.94,9.52-2.56,21.27,4.06Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.a6fd7d592360bdf7b92e3e210dca352c.svg";
export { ForwardRef as ReactComponent };